import _get from 'lodash/get';

export const isProduction = () =>
  _get(window, 'Grab.config.env') === 'production';

export const isNonProduction = () => !isProduction();

export const isDev = () => _get(window, 'Grab.config.env') === 'development';

export const isStaging = () => _get(window, 'Grab.config.env') === 'staging';
